// import types
import { AIMatchSettingsType } from 'components/types';
import { AskRoundSettingsResponse } from 'generated/index';

// import utils
import * as yup from 'yup';
import { t } from 'i18next';

export const hhmmRegex = /^(\d{1,2}):([0-5]\d)$/;

export const hourSchema = () =>
  yup
    .string()
    .required(t('validation.valueIsRequired'))
    .matches(hhmmRegex, t('validation.matchHHmm'));

const schema = yup.object().shape({
  [AIMatchSettingsType.TIMES]: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string().required(t('validation.valueIsRequired')),
        value: yup.string().required(t('validation.valueIsRequired'))
      })
    )
    .default([])
    .min(1, t('validation.greaterThan', { field: 1 }))
    .max(24, t('aiMatchSettings.maxNotificationsAllowed', { field: 24 }))
    .required(),
  [AIMatchSettingsType.BEFORE_START_LIMIT]: hourSchema(),
  [AIMatchSettingsType.FLEX_ENABLED]: yup
    .boolean()
    .default(false)
    .notRequired(),
  [AIMatchSettingsType.NON_FLEX_ENABLED]: yup
    .boolean()
    .default(false)
    .notRequired(),
  rounds: yup.array<AskRoundSettingsResponse>().default([]).notRequired()
});

export default schema;
